export default String.raw`
<script>
    $(document).ready(function() {
        const allCartsArray = [];
        const inquiryArray = [];
        let anyNotInquiryCart = false;
        {% for oneOfCart in customer.Carts -%}
            {% if oneOfCart.Inquiry -%}
                inquiryArray.push({id: Number("{{oneOfCart.Id}}"), count: Number("{{oneOfCart.Count}}")});
            {% else -%}
                anyNotInquiryCart = true;
            {% endif -%}
            allCartsArray.push({id: Number("{{oneOfCart.Id}}"), count: Number("{{oneOfCart.Count}}"), name: "{{oneOfCart.Name}}"});
        {% endfor -%}
        let activeInquiryId = -1;
        const name = 'activeInquiryId=';
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                activeInquiryId = c.substring(name.length, c.length);
            }
        }
        let savedInquiryExist = false;
        for(let i = 0; i < inquiryArray.length; i++) {
            const id = inquiryArray[i].id;
            if(activeInquiryId == id){
                savedInquiryExist = true;
            }
        }

        if(!savedInquiryExist){
            activeInquiryId = -1;
        }

        if(activeInquiryId == -1 && inquiryArray.length > 0){
            activeInquiryId = inquiryArray[inquiryArray.length - 1].id;
        }

        window.app.setCookie('activeInquiryId', activeInquiryId);

        let index = -1;
        let count = -1;
        for(let i = 0; i < inquiryArray.length; i++) {
            if(inquiryArray[i].id == activeInquiryId) {
                index = i + 1;
                count = inquiryArray[i].count;
                break;
            }
        }     
        $('.inquiry-name-to-replace-js').text(index);
        $('.inquiry-count-to-replace-js').text(count);
        if(count > 0){
            $('.inquiry-counter-js').removeClass('hidden-js');
        }
        $('.load-inquiry-js').data('inquiry-id', activeInquiryId);

        {% if page.QueryString contains 'inquiry=true' and page.PageId == config.DefinedPages.Order.Id -%}
            let cartId = window.app.getCookie('lastCartId');
            if(cartId == ''){
                cartId = -1;
            }
            if(cartId != -1 && anyNotInquiryCart){
                if ($('.change-quantity-js').length > 0) {
                    $('.change-quantity-js').prop('disabled', true);
                    $('.change-quantity-js').addClass('disabled-js');
                }
                $.post('', {__csrf: __CSRF, __action: 'Cart/Change', id: cartId}, function () {
                    $.get('', {__collection: 'customer.Cart.Count|customer.Cart.Value|customer.Cart.EditedOrderId'}, function (result) {
                        const cartCount = result.collection['customer.Cart.Count'];
                        const cartValue = result.collection['customer.Cart.Value'].toPrice();
                        const editedOrderId = result.collection['customer.Cart.EditedOrderId'];
                        if(editedOrderId != null && activeInquiryId == -1){
                            window.app.setCookie('lastCartId', -1);
                        }
                        let cartName = "{{translations.Cart}} ";
                        for(let i = 0; i < allCartsArray.length; i++) {
                            if(allCartsArray[i].id == cartId) {
                                cartName += allCartsArray[i].name;
                                break;
                            }
                        }
                        $('.small-cart-name-to-replace-js').parents('.current-cart-js').text(cartName);
                        $('.cart-count-js').text(cartCount);
                        $('.counter-bg-js').removeClass('hidden-js');
                        $('.cart-value-js').text(cartValue);
                        $('.load-cart-js[data-cart-id]').attr('data-cart-id', cartId);
                        $.post('', {__csrf: __CSRF, __action: 'Cart/Change', id: activeInquiryId}, function () {
                            if ($('.change-quantity-js').length > 0) {
                                $('.change-quantity-js').prop('disabled', false);
						        $('.change-quantity-js').removeClass('disabled-js');
                            }
                        });
                    });
                }); 
            } else {
                $('.small-cart-name-to-replace-js').parents('.current-cart-js').text('{{translations.NewCart}}');
                $('.counter-bg-js').addClass('hidden-js');
            }
        {% endif -%}
        if(window.location.search.includes('prodprice')){
            window.app.setCookie('lastCartId', {{customer.Cart.Id}});
        }
    });
</script>
`